<template>
    <div id="contents">
      <div class="inner">
        <h3 class="main-title">상담 신청</h3>
        <ul class="tab-wrap">
          <li><a href="/contact-us" class="tab-btn active">상담 신청</a></li>
          <li><a href="/map" class="tab-btn">오시는 길</a></li>
        </ul>
        <article class="consult-wrap">
          <img src="../resource/images/img_consult.png" alt="">
          <div class="consult-list-wrap">
            <form className="gform"
                  action="https://script.google.com/macros/s/AKfycbzzjW2kAXxd2DIY85oS_XaREG2QOQOhwLlsy9_EgD0L8XO6Nh36aMcuRz6O39ZGVAji/exec"
                  method="POST" data-email="dkqkfwnsgur@naver.com" v-on:submit="this.submitForm">
              <ul class="consult-list">
                <li>
                  <label class="head imp" for="company">업체명</label>
                  <span class="value"><input type="text" id="company" name="company" v-model="company" class="input"></span>
                </li>
                <li>
                  <label class="head imp" for="managerName">담당자 성함</label>
                  <span class="value"><input type="text" id="managerName" name="managerName" v-model="managerName" class="input"></span>
                </li>
                <li>
                  <label class="head imp" for="tel01">연락처</label>
                  <span class="value tel">
                    <input type="text" id="tel01" name="tel01" v-model="tel01" class="input">
                    <input type="text" id="tel02" name="tel02" v-model="tel02" class="input">
                    <input type="text" id="tel03" name="tel03" v-model="tel03" class="input">
                  </span>
                </li>
                <li>
                  <label class="head imp" for="email">이메일</label>
                  <span class="value"><input type="text" id="email" name="email" v-model="email" class="input"></span>
                </li>
                <li>
                  <label class="head imp" for="section">문의분야</label>
                  <span class="value"><input type="text" id="section" name="section" v-model="section" class="input"></span>
                </li>
                <li>
                  <label class="head imp" for="consultCnt">문의내용</label>
                  <span class="value"><textarea id="consultCnt" name="consultCnt" v-model="consultCnt" class="textarea"></textarea></span>
                </li>
              </ul>
              <div class="btn-wrap">
                <button type="submit" class="btn-blue">문의하기</button>
              </div>
            </form>
          </div>
        </article>
      </div>
    </div>
</template>

<script>
import _ from "lodash";
import Swal from "sweetalert2";

export default {
  name: 'page-contact-us',
  components: {

  },
  data () {
    return {
      company: '',
      managerName: '',
      tel01: '',
      tel02: '',
      tel03: '',
      email: '',
      section: '',
      consultCnt: '',
      curWidth: 2.5

    }
  },
  methods: {
    submitForm(e) {
      let message = '성공적으로 전송 되었습니다.';
      let icon = 'success';
      e.preventDefault();
      if(!this.isValid()) {
        icon = 'warning'
        message = '* 항목은 필수 입력 항목 입니다.'
      } else if(!this.validateEmail(this.email)) {
        icon = 'warning'
        message = 'Email주소가 유효하지 않습니다.';
      } else {
        this.submitWithoutRefresh(e);
      }
      Swal.fire({
        icon: icon,
        text: message,
      });
    },
    isValid() {
      return !(_.isEmpty(this.company) || _.isEmpty(this.managerName) || _.isEmpty(this.tel01) || _.isEmpty(this.tel02) || _.isEmpty(this.tel03) || _.isEmpty(this.email) || _.isEmpty(this.section) || _.isEmpty(this.consultCnt));
    },
    validateEmail(email) {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
      return emailRegex.test(email);
    },

    getFormData(form)  {
      let elements = form.elements;
      let honeypot;

      let fields = Object.keys(elements).filter(function(k) {
        if (elements[k].name === "honeypot") {
          honeypot = elements[k].value;
          return false;
        }
        return true;
      }).map(function(k) {
        if(elements[k].name !== undefined) {
          return elements[k].name;
          // special case for Edge's html collection
        }else if(elements[k].length > 0){
          return elements[k].item(0).name;
        }
      }).filter(function(item, pos, self) {
        return self.indexOf(item) == pos && item;
      });

      let formData = {};
      fields.forEach(function(name){
        let element = elements[name];

        // singular form elements just have one value
        formData[name] = element.value;

        // when our element has multiple items, get their values
        if (element.length) {
          let data = [];
          for (let i = 0; i < element.length; i++) {
            let item = element.item(i);
            if (item.checked || item.selected) {
              data.push(item.value);
            }
          }
          formData[name] = data.join(', ');
        }
      });

      // add form-specific values into the data
      formData.formDataNameOrder = JSON.stringify(fields);
      formData.formGoogleSheetName = form.dataset.sheet || "responses"; // default sheet name
      formData.formGoogleSendEmail
          = form.dataset.email || ""; // no email by default

      return {data: formData, honeypot: honeypot};
    },

    submitWithoutRefresh(e) {
      let form = e.target;
      let formData = this.getFormData(form);
      let data = formData.data;

      // If a honeypot field is filled, assume it was done so by a spam bot.
      if (formData.honeypot) {
        return false;
      }

      let url = form.action;
      let xhr = new XMLHttpRequest();
      xhr.open('POST', url);
      // xhr.withCredentials = true;
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status === 200) {
          form.reset();
          var formElements = form.querySelector(".form-elements")
          if (formElements) {
            formElements.style.display = "none"; // hide form
          }
          var thankYouMessage = form.querySelector(".thankyou_message");
          if (thankYouMessage) {
            thankYouMessage.style.display = "block";
          }
        }
      };
      // url encode form data for sending as post data
      var encoded = Object.keys(data).map(function(k) {
        return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
      }).join('&');
      xhr.send(encoded);

      this.company = '';
      this.managerName = '';
      this.tel01 = '';
      this.tel02 = '';
      this.tel03 = '';
      this.email = '';
      this.section = '';
      this.consultCnt = '';
    },
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("article").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth) {
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  },
  mounted() {
    document.body.classList.add('sub');
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    this.scroll();
  }

}
</script>